import firebase from "firebase/app";
import "firebase/analytics";
import { getLoggedInUser } from "./authUtils";

var firebaseConfig = {
  apiKey: "AIzaSyCWha74AaOlIfCmY5r-0C3ol9cDiH-1nD4",
  authDomain: "chungungo-88e75.firebaseapp.com",
  projectId: "chungungo-88e75",
  storageBucket: "chungungo-88e75.appspot.com",
  messagingSenderId: "423737938389",
  appId: "1:423737938389:web:660e783c9feaa60ccc6d5c",
  measurementId: "G-TNFCQ3H58Z"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

const reportEvent = (eventName, eventData) => {
  firebase.analytics().logEvent(eventName, {
    ...eventData,
    user_role: getLoggedInUser() ? getLoggedInUser().user.roles[0] : 'unregistered',
  });
}

export {
  reportEvent,
};